module.exports = __webpack_public_path__ + "img/offboarding.db468d76.jpg";